import { Component, OnInit } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { PrivacyService } from '../privacy/privacy.service';
import { constants } from '../constants';

@Component({
  selector: 'app-form-privacy',
  templateUrl: './form-privacy.component.html',
  styleUrls: ['./form-privacy.component.scss']
})
export class FormPrivacyComponent implements OnInit {
  iframeUrl: SafeResourceUrl;
  urlExerciseRight:any = {}
  policiesGroup:any = []
  isShowModal = false;
  canChargeForm:boolean = false
  modalTitle = "";
  modalContent = "";
  
  constructor(private domSanitizer: DomSanitizer, private privacyService:PrivacyService) { }

  ngOnInit() {
    this.getExerciseRight()
  }

  getExerciseRight(){
  
    this.privacyService.getExerciseRight().subscribe(((dataResponse:any) => {
      if(dataResponse['responseCode'] ==  constants.SUCCESS_WS_RESPONSE_CODE){
        this.urlExerciseRight = dataResponse.obj.value
        this.iframeUrl = this.domSanitizer.bypassSecurityTrustResourceUrl(this.urlExerciseRight);
        this.canChargeForm = true
      }else{
        this.modalTitle = "Error: ";
        this.modalContent =  "No se ha podido establecer la conexión con el servidor.";
        this.isShowModal = true;
      }
    }),
    (err) => {
      this.modalTitle = "Error: " + err.code;
      this.modalContent =  "No se ha podido establecer la conexión con el servidor.";
      this.isShowModal = true;
    });
  }
}
